<template>
    <div>
        <AlertDismiss class="mx-2" ref="alertDismiss"></AlertDismiss>

        <BaseModal v-model="modalPermissions" size="xl">
            <SettingModifyPermission :roleId="roleId" :roleLabel="roleLabel"/>
        </BaseModal>

        <b-table :busy="isBusy" :fields="fields" :items="items" sticky-header="60vh" responsive no-border-collapse
            select-mode="single" selectable @row-selected="onRowSelected">

            <template #empty>
                <b-card v-if="items.length !== 0" class="text-center my-2 fs-5">
                    No hay usuarios que coincidan con los criterios de búsqueda
                </b-card>
                <b-card v-else class="text-center my-2 fs-5">
                    Aún no se ha creado ningún usuario
                </b-card>
            </template>

            <!--icono de carque de tabla-->
            <template #table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Cargando datos de tabla...</strong>
                </div>
            </template>

            <!--botones de eliminar y editar -->
            <template #cell(selected)="{ rowSelected }">
                <template v-if="rowSelected">
                <b-button 
                    @click="openModalPermissions()" 
                    variant="outline-primary" 
                    v-b-tooltip.hover.left="'Modificar permisos'"
                    size="sm"
                >
                    <b-icon icon="shield-fill"></b-icon>
                </b-button> 
            </template>
                <template v-else>
                    <b-icon icon="three-dots" font-scale="1" class="icone-not-select"></b-icon>
                </template>
            </template>

            <!--boton de detalles -->
            <template #cell(detalle)="row">
                <b-button size="sm" @click="row.toggleDetails" variant="outline-secondary" class="mr-2">
                    <div v-if="row.detailsShowing">
                        <span class="d-none d-md-inline me-2">Ocultar</span>
                        <b-icon icon="eye-slash-fill" font-scale="1"></b-icon>
                    </div>
                    <div v-else>
                        <span class="d-none d-md-inline me-2">Ver</span>
                        <b-icon icon="eye-fill" font-scale="1"></b-icon>
                    </div>
                </b-button>
             </template>

             <!--cuerpo de detalle-->
             <template #row-details="row">
                <b-card>
                    <template v-if="!hasPermission(row)">
                        Rol sin permisos.
                    </template>
                    <template v-else>
                        Permisos asignados:
                        <ul class="mb-0">
                            <li v-bind:key="p.id" v-for="p in sortedPermissions(row.item.permission)">
                                {{ p.descripcion }}
                            </li>
                        </ul>
                    </template>
                </b-card>
            </template>
        </b-table>
    </div>
</template>
<script>
import AlertDismiss from '@/components/shared/Alert-dismiss.vue'
import { mapActions } from 'vuex';
import { EventNames } from '@/plugins/enums/index.js'
import BaseModal from '@/components/shared/Base-modal.vue';
import SettingModifyPermission from './Setting-modify-permission.vue';

export default {
    name: 'SettingListTypeUser',

    components: {
        AlertDismiss,
        BaseModal,
        SettingModifyPermission,
    },

    async mounted(){
        await this.getAllRoles();

        this.$eventBus.$on(EventNames.ModifiedPermission, async () => {
            this.cargandoTabla();
            this.refreshPermission = true;
            await this.getAllRoles();
            this.cargandoTabla();
        });

        this.$eventBus.$on(EventNames.CreatedUserType, async () => {
            this.cargandoTabla();
            await this.getAllRoles();
            this.cargandoTabla();
        });
    },

    data() {
        return {
            isBusy: false,
            modalPermissions: false,

            fields: [
                { key: 'name', label: 'Nombre del rol del usuario', thClass: 'col-8' },
                { key: 'detalle', label: 'Detalle' , thClass: 'col-2' },
                { key: 'selected', label: 'Opciones', thClass: 'col-2' },
            ],

            selected: [],

            items: [],

            refreshPermission: false,
        }
    },

    computed: {
        roleId() {
            return this.selected?.[0]?.id ?? '';
        },
        roleLabel() {
            return this.selected?.[0]?.name ?? '';
        },
    },

    methods: {
        ...mapActions(["allRoles"]),

        onRowSelected(items) {
            if (this.refreshPermission) {
                this.refreshPermission = false
                return
            }
            this.selected = items;
        },

        cargandoTabla(){
            this.isBusy = ! this.isBusy;
        },

        async getAllRoles(){
            this.cargandoTabla();
            let result = await this.allRoles();

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                this.cargandoTabla();
                return;
            }

            this.items = result.data;
            this.cargandoTabla();
        },

        openModalPermissions(){
            this.modalPermissions = true;
        },
        hasPermission(row){
            return row.item.permission.length > 0;
        },
        sortedPermissions(permissions){
            let permissionsCopy = permissions.slice();
            return permissionsCopy.sort((a, b) => a.descripcion.localeCompare(b.descripcion));
        }
    },
}
</script>
<style></style>